/**
 * Route: /people — People-Merge (v2-Relaunch)
 *
 * Kanonische Route fuer Contact+Host clientseitig gemergt (siehe
 * layouts/nav.ts, LEGACY_PATH_REDIRECTS: /contacts -> /people).
 */
import { createFileRoute } from '@tanstack/react-router'
import { ContactsPage } from '../features/contacts/ContactsPage'

export const Route = createFileRoute('/_auth/people/')({
  component: ContactsPage,
})
